document.addEventListener('DOMContentLoaded', function() {
  var glideContainer = document.querySelector('.glide-container');
    if (!glideContainer) {
    console.warn('No .glide-container found, skipping slider init');
    return;
  }
  var currentModel = glideContainer.getAttribute('data-current-model');  // Retrieve the current model
  var glideElement = document.querySelector('.glide');

  if (glideElement) {
    var slides = Array.from(glideElement.querySelectorAll('.glide__slide img'));
    var activeIndex = 0; // Default to the first slide if no active is found

    // Find and mark the active slide
    slides.forEach((img, index) => {
      if (img.dataset.productModel === currentModel) {
        img.closest('.glide__slide').classList.add('active'); // Add 'active' class to the parent slide
        activeIndex = index; // Update the index to the active slide
      }
    });

    // Initialize Glide.js at the active slide index
    var glide = new Glide(glideElement, {
      type: 'slider',
      startAt: activeIndex, // Start at the active slide
      perView: 3,
      gap: 1,
      breakpoints: {
        1000: {
          perView: 3
        },
        480: {
          perView: 3
        }
      }
    });
    glide.mount();
  } else {
    console.warn('Glide element not found');
  }
});
